module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_01@2x-265076bce2fc224b7ca14ff6d5f916d8.jpg";